import { getRedirectURL } from "../utils/utils";


export class BannerCTA {
  constructor(type, image, position, redirect, install, shopping, meta) {
    this.type = type;
    this.image = image;
    this.position = position;
    this.redirect = redirect;
    this.install = install;
    this.shopping = shopping;
    this.meta = meta;
  }

  static fromApiObject(input) {
    if (typeof (input) === "string") {
      let result = {
        [this.CTA_CONFIG.META]: {}
      };
      let configs = input.split("{:}");
      configs.forEach(config => {
        let temp = config.split("|");
        if (Object.values(this.CTA_CONFIG).includes(temp[0])) {
          result[temp[0]] = temp[1];
        } else {
          result[this.CTA_CONFIG.META][temp[0]] = temp[1];
        }
      });
      return new BannerCTA(
        result[this.CTA_CONFIG.TYPE],
        result[this.CTA_CONFIG.IMAGE],
        result[this.CTA_CONFIG.POSITION],
        result[this.CTA_CONFIG.REDIRECT],
        result[this.CTA_CONFIG.INSTALL],
        result[this.CTA_CONFIG.SHOPPING],
        result[this.CTA_CONFIG.META],
      )
    }

    return new BannerCTA();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => BannerCTA.fromApiObject(item));
    }

    if (input && (typeof (input) === "object" || typeof (input) === "string")) {
      return [BannerCTA.fromApiObject(input)];
    }

    return [];
  }

  getRedirectURL() {
    return getRedirectURL(this.redirect, this.install, this.shopping);
  }

  static CTA_CONFIG = {
    TYPE: "type",
    IMAGE: "image",
    POSITION: "position",
    REDIRECT: "redirect",
    INSTALL: "install",
    SHOPPING: "shopping",
    META: "meta",
  }
}